import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

// import useSignup from '@src/hooks/auth/signup/useSignup'
import useSignupContext from '@src/hooks/auth/signup/useSignupContext'

import Input from '@src/components/inputs/Input'
import FileSelector from '@src/components/inputs/FileSelector'

const BusinessInfoSection = () => {
	const { getFieldProps, getFileFieldProps, businessFiles } = useSignupContext()

	return (
		<>
			<FileBlock>
				<FileSelector
					{...getFileFieldProps('businessRegistrationFile', 'businessRegistration')}
					accept="image/*"
					label="사업자등록증"
					buttonTxt={businessFiles?.[0] ? '변경' : '업로드'}
				/>
				{businessFiles?.[0] && (
					<ImageBlock>
						<Image src={URL.createObjectURL(businessFiles[0])} alt="사업자등록증" />
					</ImageBlock>
				)}
			</FileBlock>
			<Input
				{...getFieldProps('businessRegistrationNumber')}
				css={inputStyle}
				label="사업자등록번호"
				placeholder="사업자등록번호를 입력해주세요."
			/>
			<FileBlock>
				<FileSelector
					{...getFileFieldProps('salesReportFile', 'salesReport')}
					accept="image/*"
					label="통신판매업증"
					buttonTxt={businessFiles?.[1] ? '변경' : '업로드'}
				/>
				{businessFiles?.[1] && (
					<ImageBlock>
						<Image src={URL.createObjectURL(businessFiles[1])} alt="통신판매업증" />
					</ImageBlock>
				)}
			</FileBlock>
			<Input
				{...getFieldProps('salesReportNumber')}
				css={inputStyle}
				label="통신판매업 신고번호"
				placeholder="통신판매업 신고번호를 입력해주세요."
			/>
			<Input
				{...getFieldProps('companyName')}
				css={inputStyle}
				label="업체(법인)명"
				placeholder="업체(법인)명을 입력해주세요."
			/>
			<Input
				{...getFieldProps('ceoName')}
				css={inputStyle}
				label="대표자명"
				placeholder="대표자명을 입력해주세요."
			/>
			<Input
				{...getFieldProps('address')}
				css={inputStyle}
				label="사업장 소재지"
				placeholder="사업장 소재지를 입력해주세요."
			/>
			<Input
				{...getFieldProps('email')}
				css={inputStyle}
				label="대표자 이메일"
				placeholder="대표자 이메일을 입력해주세요."
			/>
			<Input
				{...getFieldProps('phone')}
				css={inputStyle}
				label="대표 연락처"
				placeholder="대표 연락처을 입력해주세요."
			/>
		</>
	)
}

const inputStyle = css`
	width: 27rem;
`

const FileBlock = styled.div`
	display: flex;
	align-items: center;
`

const ImageBlock = styled.div`
	width: 10rem;
	height: 10rem;
	margin-left: 1rem;
`

const Image = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`

export default BusinessInfoSection
